var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BOverlay,
    { staticClass: "mb-3", attrs: { show: _setup.loading } },
    [
      _c(
        "div",
        {
          staticClass: "info",
          class: {
            invalid: !_setup.manufacture.isValid,
            "text-muted": !_setup.manufacture.isValid,
          },
        },
        [
          _c("strong", [_vm._v(_vm._s(_setup.props.glazing.name) + "  ")]),
          _setup.props.included
            ? _c("em", [_vm._v("(included in price)")])
            : [_vm._v(_vm._s(_setup.diffInPrice))],
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(_vm._s(_setup.props.glazing.meta.short_description)),
          ]),
        ],
        2
      ),
      _vm._l(_setup.manufacture.problems, function (problem, idx) {
        return _c(
          "p",
          { key: idx, staticClass: "mb-0 text-danger manufacture" },
          [
            _c("small", [
              _c("span", { staticClass: "material-icons mr-1" }, [
                _vm._v("handyman"),
              ]),
              _vm._v(_vm._s(problem)),
            ]),
          ]
        )
      }),
      !_setup.delivery.isValid
        ? _c("p", { staticClass: "mb-0 text-danger delivery" }, [
            _c("small", [
              _c("span", { staticClass: "material-icons mr-1" }, [
                _vm._v("bus_alert"),
              ]),
              _vm._v("Delivery Not Available (Collection Only)"),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }